import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-12 py-2" }
const _hoisted_2 = { class: "w-100 mt-2" }
const _hoisted_3 = { class: "mb-2 d-flex align-items-center" }
const _hoisted_4 = { class: "me-2" }
const _hoisted_5 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "effective-date-a" }, " Medicare Part A Effective Date ", -1 /* HOISTED */)
const _hoisted_7 = { class: "input-group date datepickerInput" }
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_10 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "effective-date-b" }, " Medicare Part B Effective Date ", -1 /* HOISTED */)
const _hoisted_12 = { class: "input-group date datepickerInput" }
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_15 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "referral-exisiting-prior" }, " Existing Prior Episodes ", -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Option", -1 /* HOISTED */)
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "effective-date-a" }, " Medicare Part A Effective Date ", -1 /* HOISTED */)
const _hoisted_21 = { class: "input-group date datepickerInput" }
const _hoisted_22 = ["value"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_24 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "effective-date-b" }, " Medicare Part B Effective Date ", -1 /* HOISTED */)
const _hoisted_26 = { class: "input-group date datepickerInput" }
const _hoisted_27 = ["value"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_29 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "referral-exisiting-prior" }, " Existing Prior Episodes ", -1 /* HOISTED */)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Option", -1 /* HOISTED */)
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "effective-date-a" }, " Medicare Part A Effective Date ", -1 /* HOISTED */)
const _hoisted_35 = { class: "input-group date datepickerInput" }
const _hoisted_36 = ["value"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_38 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "effective-date-b" }, " Medicare Part B Effective Date ", -1 /* HOISTED */)
const _hoisted_40 = { class: "input-group date datepickerInput" }
const _hoisted_41 = ["value"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_43 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "referral-exisiting-prior" }, " Existing Prior Episodes ", -1 /* HOISTED */)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Option", -1 /* HOISTED */)
const _hoisted_46 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h6", _hoisted_3, [
          _createElementVNode("b", _hoisted_4, _toDisplayString(_ctx.type) + " Medicare", 1 /* TEXT */)
        ])
      ])
    ]),
    (_ctx.type == 'Primary')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("input", {
                    name: "effective-date-a",
                    type: "text",
                    class: "form-control",
                    placeholder: "Enter Date",
                    autocomplete: "off",
                    value: _ctx.referral.Insurance.PrimaryMedicarePartADate,
                    onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_8),
                  _hoisted_9
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["getDate"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("input", {
                    name: "effective-date-b",
                    type: "text",
                    class: "form-control",
                    placeholder: "Enter Date",
                    autocomplete: "off",
                    value: _ctx.referral.Insurance.PrimaryMedicarePartBDate,
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_13),
                  _hoisted_14
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["getDate"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              name: "referral-exisiting-prior",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.referral.Insurance.PrimaryExistingPriorEpisode) = $event))
            }, [
              _hoisted_17,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (status) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: status.label,
                  value: status.value
                }, _toDisplayString(status.label), 9 /* TEXT, PROPS */, _hoisted_18))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, _ctx.referral.Insurance.PrimaryExistingPriorEpisode]
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (_ctx.type == 'Secondary')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("input", {
                    name: "effective-date-a",
                    type: "text",
                    class: "form-control",
                    placeholder: "Enter Date",
                    autocomplete: "off",
                    value: _ctx.referral.Insurance.SecondaryMedicarePartADate,
                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_22),
                  _hoisted_23
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["getDate"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("input", {
                    name: "effective-date-b",
                    type: "text",
                    class: "form-control",
                    placeholder: "Enter Date",
                    autocomplete: "off",
                    value: _ctx.referral.Insurance.SecondaryMedicarePartBDate,
                    onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_27),
                  _hoisted_28
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["getDate"])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              name: "referral-exisiting-prior",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referral.Insurance.SecondaryExistingPriorEpisode) = $event))
            }, [
              _hoisted_31,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (status) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: status.label,
                  value: status.value
                }, _toDisplayString(status.label), 9 /* TEXT, PROPS */, _hoisted_32))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, _ctx.referral.Insurance.SecondaryExistingPriorEpisode]
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (_ctx.type == 'Tertiary')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("input", {
                    name: "effective-date-a",
                    type: "text",
                    class: "form-control",
                    placeholder: "Enter Date",
                    autocomplete: "off",
                    value: _ctx.referral.Insurance.TertiaryMedicarePartADate,
                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_36),
                  _hoisted_37
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["getDate"])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("input", {
                    name: "effective-date-b",
                    type: "text",
                    class: "form-control",
                    placeholder: "Enter Date",
                    autocomplete: "off",
                    value: _ctx.referral.Insurance.TertiaryMedicarePartBDate,
                    onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_41),
                  _hoisted_42
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["getDate"])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              name: "referral-exisiting-prior",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.referral.Insurance.TertiaryExistingPriorEpisode) = $event))
            }, [
              _hoisted_45,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (status) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: status.label,
                  value: status.value
                }, _toDisplayString(status.label), 9 /* TEXT, PROPS */, _hoisted_46))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, _ctx.referral.Insurance.TertiaryExistingPriorEpisode]
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}